import type { FunnelData } from "../api.ts";

export function FunnelChart({ data, showRates = false, onStage }: { data: FunnelData; showRates?: boolean; onStage?:(stage:string)=>void }): React.JSX.Element {
  const max = Math.max(1, ...data.stages.map((stage) => stage.reached));
  return <div className="funnel-chart">{data.stages.map((stage, index) => <div key={stage.stage}>
    <div className="funnel-line" aria-label={`${stage.label}：当前 ${stage.current} 家，曾到达 ${stage.reached} 家`}><span>{stage.label}</span>
      <div className="funnel-track"><div style={{ width: `${stage.reached / max * 100}%` }} /></div>{onStage?<button className="text-link" onClick={()=>onStage(stage.stage)} aria-label={`查看${stage.label}客户`}>{stage.current}</button>:<b>{stage.current}</b>}<small>曾到达 {stage.reached}</small>
    </div>
    {showRates && index < data.stages.length - 1 && <div className="funnel-rate">{stage.toNextRate === null ? "下一阶段转化：样本不足" : `下一阶段转化：${Math.round(stage.toNextRate * 100)}%`}</div>}
  </div>)}</div>;
}
